import { render, staticRenderFns } from "./tabs-Goods.vue?vue&type=template&id=33c0b854&scoped=true&"
import script from "./tabs-Goods.vue?vue&type=script&lang=js&"
export * from "./tabs-Goods.vue?vue&type=script&lang=js&"
import style0 from "./tabs-Goods.vue?vue&type=style&index=0&id=33c0b854&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c0b854",
  null
  
)

export default component.exports